<template>
  <svg
    width="60"
    height="66"
    viewBox="0 0 60 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54 6H51V0H45V6H15V0H9V6H6C2.7 6 0 8.7 0 12V60C0 63.3 2.7 66 6 66H54C57.3 66 60 63.3 60 60V12C60 8.7 57.3 6 54 6ZM54 60H6V27H54V60ZM54 21H6V12H54V21Z"
    />
  </svg>
</template>
